'use client';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { ProductDetailPrice } from '@eliadmin/core/src/components/product/detail/product-detail-price';
import { ProductHeader } from '@eliadmin/core/src/components/product/detail/product-header';
import { ProductImages } from '@eliadmin/core/src/components/product/detail/product-images';
import { ProductQuantity } from '@eliadmin/core/src/components/product/detail/product-quantity';
import { ProductVariants } from '@eliadmin/core/src/components/product/detail/variants/product-variants';
import { CarouselProvider } from '@eliadmin/core/src/components/ui/carousel-context';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ProductTags } from './product-tags';
import { ProductDeliveryReturn } from './product-delivery-return';
import { ProductAskDialog } from '@eliadmin/core/src/components/product/detail/product-ask-dialog';
import { ProductAdditionalInfo } from './product-additional-info';
import { ProductPrice } from '../product-price';
import { ProductCustomPrice } from './product-custom-price';

export function ProductInfo({ product }: { product: ProductDetailData }) {
  return (
    <section
      className={cn(
        'custom-section',
        'relative pb-[50px] pt-[158px] sm:pb-16 sm:pt-[180px] lg:pb-[100px] lg:pt-[220px] xl:pt-[240px]',
      )}
    >
      <div
        className={cn(
          'custom-container',
          'relative z-10 flex flex-col items-center justify-center gap-12 sm:gap-14 md:flex-row md:items-start md:justify-between lg:gap-16',
        )}
      >
        <div className="w-full sm:max-w-[690px]">
          <CarouselProvider>
            <ProductImages />
          </CarouselProvider>
        </div>
        <div className="flex w-full flex-col items-start justify-start gap-6 md:max-w-[486px]">
          <ProductHeader product={product} />
          {/* {product.variants && product.variants.length > 0 && <ProductVariants />} */}
          <ProductTags product={product} />
          <ProductDetailPrice />
          <ProductQuantity />
          <ProductAskDialog title={product.name} />
          <Separator />
          <ProductAdditionalInfo product={product} />
          <Separator />
          <ProductDeliveryReturn />
        </div>
      </div>
    </section>
  );
}

function Separator({ className }: { className?: string }) {
  return <div className={cn('h-[1px] w-full bg-border', className)} />;
}
